import dynamic from 'next/dynamic'

import { Container, Row, Column } from './base/gridview'
import InstagramPostsList from './widgets/instagram-posts-list'

const Button = dynamic(() => import('./base/button'))
const Heading = dynamic(() => import('./base/heading'))
const Paragraph = dynamic(() => import('./base/paragraph'))
const Html = dynamic(() => import('./base/html'))
const Section = dynamic(() => import('./base/section'))
const Image = dynamic(() => import('./base/image'))
const Video = dynamic(() => import('./base/video'))
const Breadcrumbs = dynamic(() => import('./base/breadcrumbs'))

const Header = dynamic(() => import('./widgets/header'))
const Footer = dynamic(() => import('./widgets/footer'))
const FooterV2 = dynamic(() => import('./widgets/footer-v2'))
const CustomSection = dynamic(() => import('./widgets/section'))
const Hero = dynamic(() => import('./widgets/hero'))
const SectionSlideshow = dynamic(() => import('./widgets/section-slideshow'))
const SustainabilitySlideshow = dynamic(
  () => import('./widgets/sustainability-slideshow'),
)
const GallerySlideshow = dynamic(() => import('./widgets/gallery-slideshow'))
const VideoBanner = dynamic(() => import('./widgets/video-banner'))
const DetailBanner = dynamic(() => import('./widgets/detail-banner'))
const SustainabilityDestinations = dynamic(
  () => import('./widgets/sustainable-list'),
)
const FacilityList = dynamic(() => import('./widgets/facility-list'))
const Slideshow = dynamic(() => import('./widgets/slideshow'))
const MultipleSlideShow = dynamic(() => import('./widgets/multiple-slideshow'))
const SlideshowTV = dynamic(() => import('./widgets/slideshow-tv'))
const ParallaxScrolling = dynamic(() => import('./widgets/parallax-scrolling'))
const GallerySlider = dynamic(() => import('./widgets/gallery-slider'))
const InstagramPosts = dynamic(() => import('./widgets/instagram-posts'))
const ParallaxBanner = dynamic(() => import('./widgets/parallax-banner'))
const NegativeWrapper = dynamic(() => import('./widgets/negative-wrapper'))
const PhotoGallery = dynamic(() => import('./widgets/photo-gallery'))
const PageDetailHeader = dynamic(() => import('./widgets/page-detail-header'))
const SocialShare = dynamic(() => import('./widgets/social-share'))
const HeadlineTitle = dynamic(() => import('./widgets/headline-title'))
const AnimatedHero = dynamic(() => import('./widgets/animated-hero'))
const MichelinMap = dynamic(() => import('./widgets/michelin-map'))
const MichelinRestaurantSlider = dynamic(
  () => import('./widgets/michelin-restaurants-slider'),
)
const BlogSlider = dynamic(() => import('./widgets/blog-slider'))
const BlogBanner = dynamic(() => import('./widgets/blog-banner'))
const Senses = dynamic(() => import('./widgets/senses'))
const BlueFlagMap = dynamic(() => import('./widgets/blue-flag-map'))
const BlogItem = dynamic(() => import('./widgets/blog-item'))
const Accordion = dynamic(() => import('./widgets/accordion'))
const RouteAccordion = dynamic(() => import('./widgets/route-accordion'))

const WhatsOnBanner = dynamic(() => import('./widgets/whats-on/banner'))
const WhatsOnSlideShow = dynamic(() => import('./widgets/whats-on/slide-show'))
const WhatsonEventList = dynamic(
  () => import('./widgets/whats-on/whatson-event-list'),
)

const Popup = dynamic(() => import('./widgets/whats-on/popup'))
const WhatsOnDetail = dynamic(() => import('./widgets/whats-on/detail'))
const MyProfile = dynamic(() => import('./widgets/my-profile'))
const Dengage = dynamic(() => import('./widgets/dengage'))
const HealthTourism = dynamic(() => import('./widgets/health-tourism'))
const DetailBannerV2 = dynamic(() => import('./widgets/detail-banner-v2'))
const PlanYourTrip = dynamic(() => import('./widgets/plan-your-trip'))
const HeroSingle = dynamic(() => import('./widgets/hero/single'))
const DetailBannerV3 = dynamic(() => import('./widgets/detail-banner-v3'))
const SliderTimer = dynamic(() => import('./widgets/slider-timer'))
const Series = dynamic(() => import('./widgets/series'))
const CarouselSlider = dynamic(() => import('./widgets/carousel-slider'))
const FeaturedSlider = dynamic(() => import('./widgets/featured-slider'))
const BlogSliderV2 = dynamic(() => import('./widgets/blog-slider-v2'))
const EntityCard = dynamic(() => import('./widgets/entity-card'))
const CardBanner = dynamic(() => import('./widgets/card-banner'))
const GoTurkiyeTvList = dynamic(() => import('./widgets/goturkiye-tv-list'))
const BlogList = dynamic(() => import('./widgets/blog-list'))
const SustainableTitle = dynamic(() => import('./widgets/sustainable-title'))
const SeriesList = dynamic(() => import('./widgets/series/series-list'))
const YoutubeCard = dynamic(() => import('./widgets/series/youtube-card'))

export default function getter(name: string) {
  switch (name) {
    case 'container':
      return Container
    case 'heading':
      return Heading
    case 'paragraph':
      return Paragraph
    case 'html':
      return Html
    case 'row':
      return Row
    case 'column':
      return Column
    case 'button':
      return Button
    case 'image':
      return Image
    case 'section':
      return Section
    case 'video':
      return Video

    case 'wap-gt-header':
      return Header
    case 'wap-gt-footer':
      return Footer
    case 'wap-gt-footer-v2':
      return FooterV2
    case 'wap-gt-custom-selection':
      return CustomSection
    case 'wap-gt-hero':
      return Hero
    case 'wap-gt-section-slideshow':
      return SectionSlideshow
    case 'wap-gt-s-slideshow':
      return SustainabilitySlideshow
    case 'wap-gt-gallery-slideshow':
      return GallerySlideshow
    case 'wap-gt-breadcrumbs':
      return Breadcrumbs
    case 'wap-gt-video-banner':
      return VideoBanner
    case 'wap-gt-detay-banner':
      return DetailBanner
    case 'wap-gt-sustainable-list':
      return SustainabilityDestinations
    case 'wap-gt-facility-list':
      return FacilityList
    case 'wap-gt-slideshow':
      return Slideshow
    case 'wap-gt-multiple-slideshow':
      return MultipleSlideShow
    case 'wap-gt-tv-slideshow':
      return SlideshowTV
    case 'wap-gt-parallax-scrolling':
      return ParallaxScrolling
    case 'wap-gt-gallery-slider':
      return GallerySlider
    case 'wap-gt-instagram-posts':
      return InstagramPosts
    case 'wap-gt-parallax-banner':
      return ParallaxBanner
    case 'wap-gt-negative-wrapper':
      return NegativeWrapper
    case 'wap-gt-photo-gallery':
      return PhotoGallery
    case 'wap-gt-page-detail-header':
      return PageDetailHeader
    case 'wap-gt-social-share':
      return SocialShare
    case 'wap-gt-headline-title':
      return HeadlineTitle
    case 'wap-gt-animated-hero':
      return AnimatedHero
    case 'wap-gt-michelin-map':
      return MichelinMap
    case 'wap-gt-michelin-slider':
      return MichelinRestaurantSlider
    case 'wap-gt-blog-slider':
      return BlogSlider
    case 'gt-blog-banner':
      return BlogBanner
    case 'wap-gt-senses':
      return Senses
    case 'wap-gt-blue-flag-map':
      return BlueFlagMap
    case 'gt-blog-item':
      return BlogItem
    case 'wap-gt-accordion':
      return Accordion
    case 'wap-gt-route-accordion':
      return RouteAccordion
    case 'wap-gt-whats-on-banner':
      return WhatsOnBanner
    case 'wap-gt-whats-on-slide-show':
      return WhatsOnSlideShow
    case 'wap-gt-whatson-events':
      return WhatsonEventList
    case 'wap-gt-popup':
      return Popup
    case 'wap-gt-whats-on-detail':
      return WhatsOnDetail
    case 'wap-gt-my-profile':
      return MyProfile
    case 'wap-gt-dengage':
      return Dengage
    case 'wap-gt-health-tourism':
      return HealthTourism
    case 'wap-gt-detay-banner-v2':
      return DetailBannerV2
    case 'wap-gt-plan-your-trip':
      return PlanYourTrip
    case 'wap-gt-single-hero':
      return HeroSingle
    case 'wap-gt-detay-banner-v3':
      return DetailBannerV3
    case 'wap-gt-slider-timer':
      return SliderTimer
    case 'wap-gt-series-video-player':
      return Series
    case 'wap-gt-carousel-slider':
      return CarouselSlider
    case 'wap-gt-featured-slider-v2':
      return FeaturedSlider
    case 'wap-gt-blog-slider-v2':
      return BlogSliderV2
    case 'wap-gt-entity-card':
      return EntityCard
    case 'wap-gt-card-banner':
      return CardBanner
    case 'wap-gt-goturkiye-tv-list':
      return GoTurkiyeTvList
    case 'wap-gt-blog-list':
      return BlogList
    case 'wap-gt-sustainable-title':
      return SustainableTitle
    case 'wap-gt-instagram-list':
      return InstagramPostsList
    case 'wap-gt-series-list':
      return SeriesList
    case 'wap-gt-youtube-card':
      return YoutubeCard
  }
}
